import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generarResumenDeCargasDeGasolina'
})
export class GenerarResumenDeCargasDeGasolinaPipe implements PipeTransform {

  transform(cargasDeGasolina:Array<any>, unidad:string, operador:string): any {
    // Checa que por lo menos haya una carga de gasolina qué mostrar 
    // Y que por lo menos esté activado uno de los dos filtros de unidad u operador
    if(cargasDeGasolina.length > 0 && (unidad != '' || operador != '')){
      /**
       * Revisa los siguientes casos:
       * 1.- Si el usuario seleccionó un filtro de operador pero no tiene filtro de unidad
       * realiza un promedio del rendimiento en el periodo seleccionado
       * 2.- Si el usuario selecciona una unidad sin importar si seleccionó un operador o no, 
       * obtiene el kilometraje inicial, el final y el promedio del rendimiento
       */
      let resumen = {
        kilometrajeInicial : '0',
        kilometrajeFinal : '0',
        rendimientoPromedio : '0'
      };  
      
      // Obtiene el redimiento promedio de las cargas de gasolina
      // Inicializa la cantidad de cargas
      let numeroDeCargas = 0;
      let sumaRendimiento = 0;
      cargasDeGasolina.forEach(carga => {
        sumaRendimiento += carga.rendimiento;
        numeroDeCargas++;
      });
      resumen.rendimientoPromedio = Number(sumaRendimiento / numeroDeCargas).toFixed(2);
      
      // El usuario tiene seleccionado el filtro de unidad
      if(unidad != ''){
        // Sólo hay una carga de gasolina, por lo tanto almacena el kilometraje inicial y final igual
        resumen.kilometrajeInicial = cargasDeGasolina[0].kilometrajeDeUnidad;
        if(cargasDeGasolina.length == 1)
          resumen.kilometrajeFinal = cargasDeGasolina[0].kilometrajeDeUnidad;
        else
          resumen.kilometrajeFinal = cargasDeGasolina[cargasDeGasolina.length - 1].kilometrajeDeUnidad;
      }
      return resumen;
    } else {
      return undefined;
    }
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/generar-resumen-de-cargas-de-gasolina.pipe.ts